var EHDI = EHDI || Object.create(null);

EHDI.Scene = function () {
    EHDI.aka.Container.call(this);
  };

EHDI.Scene.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.Scene.prototype.screenWillAppear = function () {

  };

EHDI.Scene.prototype.screenDidAppear = function () {

  };

EHDI.Scene.prototype.screenWillDisappear = function () {

  };

EHDI.Scene.prototype.screenDidDisappear = function () {

  };

EHDI.Scene.prototype.init = function () {

};

EHDI.Scene.prototype.reset = function () {

};

EHDI.Scene.prototype.gameStart = function () {

};

EHDI.Scene.prototype.onScreenResize = function () {

};
